window.xvk = btoa(location.search.substr(1))



// WEBPACK FOOTER //
// ./src/xvksign.js